import styled from "styled-components";

export const SolutionHistoryWrapper = styled.div`
  width: 1058px;
  background: #fff;
  position: fixed;
  z-index: 1000;
  box-shadow: 0px 4px 4px 0px #00000040;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 13px;
  padding: 40px;
  min-height: 655px;
`;

export const SolutionHistoryHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  > .left {
    display: flex;
    gap: 25px;
    align-items: center;
    > img {
      cursor: pointer;
    }
  }

  .button {
    border-radius: 15px;
    border: 1px solid #b7b7b7;
    background: #fff;
    display: flex;
    height: 40px;
    padding: 0 11px;
    justify-content: center;
    align-items: center;
    color: #000;
    font-family: Pretendard;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    cursor: pointer;
  }
`;

export const SolutionHistoryTable = styled.div`
  padding-top: 40px;
  width: 100%;
  min-height: 515px;

  .item {
    width: 15%;
  }

  .i2 {
    width: 20%;
  }

  .i4,
  .i5,
  .i6 {
    width: 10%;
  }
`;

export const SolutionHistoryThead = styled.div`
  display: flex;
  width: 100%;
  padding: 0 15px;
  box-sizing: border-box;

  > .item {
    font-family: Pretendard;
    font-weight: 500;
    font-size: 11.47px;
    text-align: center;
  }
`;

export const SolutionHistoryListWrapper = styled.div`
  display: flex
  flex-direction: column;

  > .no-data {
    text-align: center;
    width: 100%;
    margin-top: 30px;
    font-family: Pretendard;
    font-weight: 500;
    font-size: 15px;
  }
`;

export const SolutionHistoryItemWrapper = styled.div`
  display: flex;
  background: #ecf0f3;
  height: 40px;
  border-radius: 11.47px;
  margin-top: 10px;
  padding: 0 15px;
  box-sizing: border-box;

  > .item {
    font-family: Pretendard;
    font-weight: 500;
    font-size: 11.47px;
    text-align: center;
    line-height: 40px;
  }

  > .i1 {
    display: flex;
    align-items: center;
    justify-content: center;

    > span {
      height: 23px;
      border-radius: 5.73px;
      background: #373636;
      color: #fff;
      padding: 0 20px;
      line-height: 23px;
    }
  }

  > .i2 {
    display: flex;
    align-items: center;
    justify-content: center;

    > span {
      height: 23px;
      border-radius: 5.73px;
      background: #d9d9d9;
      padding: 0 20px;
      line-height: 23px;
    }
  }
`;
